// Agent module — GeminiAgentRuntime + persona system + policies

export {
  GeminiAgentRuntime,
  type AgentContentPart,
  type AgentRunResult,
  type AgentToolCallOptions,
  type AgentToolExecutor,
} from "./gemini-agent-runtime"

export {
  requiresConfirmation,
  buildConfirmation,
  type ConfirmationResult,
} from "./confirmation-policy"

export {
  formatToolError,
  classifyError,
  type ErrorClassification,
} from "./error-formatter"

export type { AgentPersona } from "./persona/types"
export { shoppingPersona } from "./persona/shopping"
export { dashboardPersona } from "./persona/dashboard"
export { genericPersona } from "./persona/generic"
export { partnerPersona } from "./persona/partner"
export { detectPersona } from "./persona/detect"

export {
  DgxLlmDriver,
  toOpenAiMessages,
  DGX_DEFAULT_MAX_TOKENS,
  DGX_TIMEOUT_MS,
  type DgxLlmDriverOptions,
} from "./dgx-llm-driver"
export { GeminiLlmDriver } from "./llm-driver"
export type {
  LlmDriver,
  LlmGenerateArgs,
  LlmGenerateResult,
  LlmToolDecl,
  NormalizedContent,
  NormalizedPart,
} from "./llm-driver"
